<template>
  
</template>

<script>
export default {
  name: 'LogoutPage',
  mounted() {
    // 1. Delete the token
    localStorage.removeItem('token');

    // 2. Redirect immediately using Vue 2 syntax (this.$router)
    // .replace() prevents the user from going back to the authenticated state
    this.$router.replace('/');
    
    // Optional: If you use a global event bus or store, you might need to reset user state here too
    // location.reload() is a brute-force way to ensure all states are reset, 
    // but this.$router.replace('/') is cleaner for Single Page Apps.
  }
}
</script>

<style scoped>
.logout-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #666;
  font-size: 1.2rem;
}
</style>